import { useAuth0 } from "@auth0/auth0-react";
import React, { useEffect } from "react";
import styled from "@emotion/styled";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LinearProgress, Typography, Paper, Box } from "@mui/material";

import { ReactComponent as LogoImage } from "../../vendor/logo.svg";
import useAuth from "../../hooks/useAuth";

const Wrapper = styled(Paper)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  min-height: 100vh;
  background: #fff;
`;

const Brand = styled(LogoImage)`
  fill: #6371F7;
  width: 264px;
  height: 64px;
  margin-bottom: 48px;
`;

const ProgressContainer = styled(Box)`
  width: 280px;
  margin-top: 24px;
`;

const StyledLinearProgress = styled(LinearProgress)`
  height: 6px;
  border-radius: 3px;
  background-color: #E8EAFC;
  & .MuiLinearProgress-bar {
    background-color: #6371F7;
    border-radius: 3px;
  }
`;

function Landing() {
  const { isAuthenticated, user, isLoading } = useAuth0();
  const { setAccessToken, setUserId } = useAuth();
  const [URLSearchParams] = useSearchParams();

  const navigate = useNavigate();
  useEffect(() => {
    if (isLoading) return;
    if (isAuthenticated) {
      setAccessToken().then((res) => {
        if (res) {
          if (user.email_verified !== false) {
            const returnTo = window.localStorage.getItem("returnTo");
            navigate(returnTo && returnTo !== "/" ? returnTo : "/v2/overview");
          } else {
            navigate("/auth/verify-email");
          }
        }
      });
    } else {
      if (URLSearchParams.get("error") === "access_denied") {
        const desc = URLSearchParams.get("error_description");

        if (desc.indexOf("verify-email") === 0) {
          const user_id = desc.substring(13);
          setUserId(user_id);
          navigate("/auth/verify-email");
        } else {
          navigate(`/auth/forbidden?error_description=${desc}`);
        }
      } else {
        navigate("/auth/login");
      }
    }
  }, [isAuthenticated, user, isLoading, setAccessToken, navigate, URLSearchParams, setUserId]);

  return isLoading || isAuthenticated ? (
    <Wrapper>
      <Brand />
      <Typography
        sx={{
          fontSize: '18px',
          fontWeight: 400,
          color: '#1a1a2e',
        }}
      >
        Loading...
      </Typography>
      <ProgressContainer>
        <StyledLinearProgress />
      </ProgressContainer>
    </Wrapper>
  ) : null;
}

export default Landing;
